import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { CuttingTableService } from '../cutting_table.service';
import * as cutting_tableActions from './cutting_table.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { User } from '../../../_models/user';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as rootActions from '../../../state/app.actions';
import * as fromRoot from '../../../state/app.reducer';
import { CuttingTable } from '../../../_models/cutting_table';
import { CuttingTableType } from '../../../_models/cutting_table_type';

@Injectable()
export class CuttingTableEffects {

    @Effect()
    loadCuttingTable$ = this.actions$.pipe(
        ofType(cutting_tableActions.CuttingTableActitonTypes.LoadCuttingTables),
        mergeMap((action: cutting_tableActions.LoadCuttingTables) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadCuttingTables =');
                // console.log(action.payload);

                return this.cutting_tableService.getCuttingTables(action.payload).pipe(
                    map((cutting_tables: CuttingTable[]) => {
                        this.changingLoading(false);
                        return new cutting_tableActions.LoadCuttingTablesSuccess(cutting_tables);
                    }),
                    catchError(err => of(new cutting_tableActions.LoadCuttingTablesFail(err)))
                );
            }
        )
    );

    @Effect()
    loadCuttingTableTypes$ = this.actions$.pipe(
        ofType(cutting_tableActions.CuttingTableActitonTypes.LoadCuttingTableTypes),
        mergeMap((action: cutting_tableActions.LoadCuttingTableTypes) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadCuttingTables =');
                // console.log(action.payload);

                return this.cutting_tableService.getCuttingTableTypes(action.payload).pipe(
                    map((cutting_tables: CuttingTableType[]) => {
                        this.changingLoading(false);
                        return new cutting_tableActions.LoadCuttingTableTypesSuccess(cutting_tables);
                    }),
                    catchError(err => of(new cutting_tableActions.LoadCuttingTableTypesFail(err)))
                );
            }
        )
    );

    // NOTA: Lanzar directamente otra acción sin llamar a ningún servicio.
    // @Effect()
    // loadCuttingTableSuccess$ = this.actions$.pipe(
    //     ofType(cutting_tableActions.CuttingTableActitonTypes.LoadCuttingTablesSuccess),
    //     map((action: rootActions.ChangeLoading) => (new rootActions.ChangeLoading(false)))
    // );

    // NOTA: sin usar Loading ni ventanas de información.
    // @Effect()
    // updateCuttingTable$: Observable<Action> = this.actions$.pipe(
    //     ofType(cutting_tableActions.CuttingTableActitonTypes.UpdateCuttingTable),
    //     map((action: cutting_tableActions.UpdateCuttingTable) => action.payload),
    //     mergeMap(( cutting_table: CuttingTable) =>
    //         this.cutting_tableService.updateCuttingTable(cutting_table).pipe(
    //         map(updatedCuttingTable => (new cutting_tableActions.UpdateCuttingTableSuccess(updatedCuttingTable))),
    //         catchError(err => of(new cutting_tableActions.UpdateCuttingTableFail(err)))
    //     ))
    // );

    @Effect()
    updateCuttingTable$ = this.actions$.pipe(
        ofType(cutting_tableActions.CuttingTableActitonTypes.UpdateCuttingTable),
        mergeMap((action: cutting_tableActions.UpdateCuttingTable) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateCuttingTable =');
                // console.log(action.payload);

                return this.cutting_tableService.updateCuttingTable(action.payload).pipe(
                    map((cutting_table: CuttingTable) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server UpdateCuttingTable =');
                        console.log(cutting_table);
                        if (cutting_table !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/cutting_table', null, 'info');
                            return new cutting_tableActions.UpdateCuttingTableSuccess(cutting_table);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new cutting_tableActions.UpdateCuttingTableFail('ERROR UpdateCuttingTable effect.');
                        }
                    }),
                    catchError(err => of(new cutting_tableActions.UpdateCuttingTableFail(err)))
                );
            }
        )
    );

    @Effect()
    CreateCuttingTable$ = this.actions$.pipe(
        ofType(cutting_tableActions.CuttingTableActitonTypes.CreateCuttingTable),
        mergeMap((action: cutting_tableActions.CreateCuttingTable) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateCuttingTable =');
                // console.log(action.payload);

                return this.cutting_tableService.createCuttingTable(action.payload).pipe(
                    map((cutting_table: CuttingTable) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server CreateCuttingTable =');
                        // console.log(cutting_table);
                        if (cutting_table !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/cutting_table', null, 'info');
                            return new cutting_tableActions.CreateCuttingTableSuccess(cutting_table);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new cutting_tableActions.CreateCuttingTableFail('ERROR CreateCuttingTable effect.');
                        }
                    }),
                    catchError(err => of(new cutting_tableActions.CreateCuttingTableFail(err)))
                );
            }
        )
    );

    @Effect()
    deleteCuttingTable$ = this.actions$.pipe(
        ofType(cutting_tableActions.CuttingTableActitonTypes.DeleteCuttingTable),
        mergeMap((action: cutting_tableActions.DeleteCuttingTable) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteCuttingTable =');
                // console.log(action.payload);

                return this.cutting_tableService.deleteCuttingTable(action.payload).pipe(
                    map((cutting_tableId: bigint) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server DeleteCuttingTable =');
                        console.log(cutting_tableId);
                        if (cutting_tableId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new cutting_tableActions.DeleteCuttingTableSuccess(cutting_tableId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new cutting_tableActions.DeleteCuttingTableFail('ERROR DeleteCuttingTable effect.');
                        }
                    }),
                    catchError(err => of(new cutting_tableActions.DeleteCuttingTableFail(err)))
                );
            }
        )
    );

    @Effect()
    loadUsers$ = this.actions$.pipe(
        ofType(cutting_tableActions.CuttingTableActitonTypes.LoadUsers),
        mergeMap((action: cutting_tableActions.LoadUsers) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadUsers =');
                // console.log(action.payload);

                return this.cutting_tableService.getUsers().pipe(
                    map((users: User[]) => {
                        this.changingLoading(false);
                        return new cutting_tableActions.LoadUsersSuccess(users);
                    }),
                    catchError(err => of(new cutting_tableActions.LoadUsersFail(err)))
                );
            }
        )
    );

    // -----------------------------

    constructor(private actions$: Actions,
                private cutting_tableService: CuttingTableService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        console.log('---->>>>.... Ejecutando CuttingTable Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin }));
    }
}
